import { CALCULATING_TAXES_SUCCESS } from './TaxCalculationConstants';
import axios from 'axios';
import { STRING, NUMBER, DATE } from 'shared/constants/InvoiceFiltersTypes';

const getUrlFilterParams = filtersState => {
  let urlFilterParams = ``;
  filtersState.map(invFilter => {
    if ((invFilter.data.type === STRING || invFilter.data.type === DATE) && invFilter.data.value) {
      urlFilterParams += `&${invFilter.data.key}=${invFilter.data.value}`;
    }
    if (invFilter.data.type === NUMBER) {
      if (invFilter.data.min.value) {
        urlFilterParams += `&${invFilter.data.min.key}=${invFilter.data.min.value}`;
      }
      if (invFilter.data.max.value) {
        urlFilterParams += `&${invFilter.data.max.key}=${invFilter.data.max.value}`;
      }
    }
  });
  return urlFilterParams;
};

const calculatingInvoicesTaxesSuccess = () => ({ type: CALCULATING_TAXES_SUCCESS });

const url = 'utm/v1/tax-calculation';
const reEvalUrl = '/re-eval';

export const calculateInvoicesTaxes = invoices => dispatch => {
  axios.post(`${url}${reEvalUrl}`, invoices)
    .then(() => {
      dispatch(calculatingInvoicesTaxesSuccess());
    })
    .catch(error => { throw error; } );
};

export const calculateTaxesForAllInvoices = (periodId, statusId) => (dispatch, getState) => {
  const filtersParams = getUrlFilterParams(getState().invoiceFilters.tempFilters);
  axios.post(`${url}${reEvalUrl}/all?periodId=${periodId}${statusId !== '-' ? `&lineStatusId=${statusId}` : ''
  }${filtersParams}`, []
  )
    .then(() => {
      dispatch(calculatingInvoicesTaxesSuccess());
    })
    .catch(error => { throw error; } );
};



// WEBPACK FOOTER //
// ./src/redux/taxCalculation/TaxCalculationActions.js